export var strings = {
  events: {
    ACCEPTED_FILES: 'Single Application - Applicant Requirements - Accepted Files',
    FLAGGED_DOCUMENTS_ACCEPTED: 'Single Application - Applicant Requirements - Flagged Documents Accepted',
    FLAGGED_DOCUMENTS_REJECTED: 'Single Application - Applicant Requirements - Flagged Documents Rejected',
    REJECTED_FILES: 'Single Application - Applicant Requirements - Rejected Files',
    UPDATED_FILE_DECISION: 'Single Application - Applicant Requirements - Updated File Decision',
    FOLLOWED_PLAGIARISM_LINK: 'Single Application - Applicant Requirements - User Followed Link to Plagiarism Service',
    PLAGIARISM_CHECK_SUCCESS: 'Single Application - Applicant Requirements - Plagiarism Check Success',
    PLAGIARISM_CHECK_ERROR: 'Single Application - Applicant Requirements - Plagiarism Check Error'
  }
};